// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LDKD","colBig":"styles_colBig__3eSgG","colSmall":"styles_colSmall__3cne9"};